import { render, staticRenderFns } from "./learningCourse.vue?vue&type=template&id=7d4d24f2&"
import script from "./learningCourse.vue?vue&type=script&lang=ts&"
export * from "./learningCourse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports